module.exports = __webpack_public_path__ + "img/breadcrumb-arrow.svg";